// removed by extract-text-webpack-plugin
module.exports = {"workPanel":"styles__workPanel__3T-uo","panelImage":"styles__panelImage__2ShfS","artistInfo":"styles__artistInfo__2Zo4T","moreWorkSlider":"styles__moreWorkSlider__2-3-_","slide":"styles__slide__VuXYv","nextArrowBackdrop":"styles__nextArrowBackdrop__8I4SG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MoreWork/styles.scss
// module id = 396
// module chunks = 0